import Base from "./Base";

class Account extends Base {
    static saveUserDetails(firstName, lastName) {
        return this.sendRequest("/account/save-user-details", "POST", {
            first_name: firstName,
            last_name: lastName
        });
    }

    static getLoggedInUserDetails() {
        return this.sendRequest("/account/get-logged-in-user-details", "GET");
    }

    static getUserApiKeys() {
        return this.sendRequest("/account/get-user-api-keys", "POST");
    }
    
    static getActiveUsers() {
        return this.sendRequest("/account/get-active-users", "POST");
    }

    static createUserApiKey(body) {
        return this.sendRequest("/account/create-user-api-key", "POST", {}, body);
    }

    static deleteApiKey(body) {
        return this.sendRequest("/account/delete-api-key", "POST", {}, body);
    }

    static handleViewApiKeyOnce(body) {
        return this.sendRequest("/account/view-api-key-once", "POST", {}, body);
    }

    static getApiKeyRequests() {
        return this.sendRequest("/account/get-api-key-requests", "POST");
    }

    static updateApiKeyRequestStatus(body) {
        return this.sendRequest("/account/update-api-key-request-status", "POST", {}, body);
    }

    static requestApiKey(body) {
        return this.sendRequest("/account/create-api-key-request", "POST", {}, body);
    }

    static generateOTP() {
        return this.sendRequest("/account/generate-otp", "GET");
    }

    static updateOnboardingPrompt(body) {
        return this.sendRequest("/account/update-onboarding-prompt", "POST", {}, body);
    }
    
}

export default Account;